import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, Input,
  OnInit
} from '@angular/core';
import {
  CondivisionePosizione
} from "../../../classes/common/codivisione-posizione";
import {
  ViewService
} from "../../../services/common/view.service";
import {
  ModalController,
  NavController
} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {
  DataService
} from "../../../services/common/data.service";
import {
  ApiService
} from "../../../services/common/api.service";
import {
  AuthService
} from "../../../services/common/auth.service";
import {Utility} from "../../../classes/common/utility";
import {
  Partecipant
} from "../../../classes/common/partecipant";
import * as moment from "moment";
import { Clipboard } from '@capacitor/clipboard';

@Component({
  selector: 'app-condiviosione-posizione-add',
  templateUrl: './condiviosione-posizione-add.component.html',
  styleUrls: ['./condiviosione-posizione-add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CondiviosionePosizioneAddComponent  implements OnInit {

  @Input() link: CondivisionePosizione;

  steps = [
    "CONDIVISIONE_POSIZIONE_ADD.step1",
    "CONDIVISIONE_POSIZIONE_ADD.step2",
    "CONDIVISIONE_POSIZIONE_ADD.step3",
    "CONDIVISIONE_POSIZIONE_ADD.step4",
  ];
  pageContent = 1;
  mode: 'visualizza';

  name: string;
  nameError: string;
  note: string;
  vehicle: Partecipant;
  vehicleError: string;
  enableVehicle: boolean = true;
  date: string;
  date_options: any = {
    date: {
      weekday: 'short',
      month: 'long',
      day: '2-digit',
    },
    time: {
      hour: '2-digit',
      minute: '2-digit',
    }
  };
  dateError: string;
  tempEmail: string;
  emails: string[] = [];
  add_time_chips: any[] = [];
  url: string;
  show_testo_copiato: boolean;

  lang: any;
  listener = {
    view: null
  };

  constructor(
    private cd: ChangeDetectorRef,
    private modalCtrl: ModalController,
    public view: ViewService,
    private translate: TranslateService,
    private data: DataService,
    private api: ApiService,
    private navCtrl: NavController
  ) { }

  ngOnInit() {
    this.translate.get('CONDIVISIONE_POSIZIONE_ADD').subscribe((lang: any) => {
      this.lang = lang;
      this.add_time_chips = [
        {
          id: '1h',
          lbl: this.lang.un_ora,
        },
        {
          id: '1gg',
          lbl: this.lang.un_giorno,
        },
        {
          id: '1sett',
          lbl: this.lang.una_settimana,
        }
      ];
      if(this.link){
        this.date = moment(this.link.expiration_date).format('YYYY-MM-DDTHH:mm');
        this.vehicle = this.link.$participant;
        this.name = this.link.name;
        this.emails = this.link.emails;
        this.url = this.link.url;
        this.note = this.link.note;
        this.enableVehicle = false;
      }else{
        this.date = moment().add(1, 'd').format('YYYY-MM-DDTHH:mm');
      }
    });
    if(this.mode == 'visualizza') this.pageContent = 7;
    ViewService.updateView.next(undefined);
  }

  ionViewWillEnter(){
    if(!AuthService.isLogged) this.navCtrl.navigateRoot('login');
  }

  ionViewDidEnter() {
    this.listenerView();
  }

  ionViewWillLeave() {
    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }
  }

  changePageContent(val: number) {
    if(val > 0){
      switch (this.pageContent) {
        case 1:
          this.checkFormError('vehicle', true);
          if(this.vehicleError){
            return this.view.modalAlert(this.lang.attenzione, this.vehicleError, 'warn', this.lang.ok);
          }
          break;
        case 2:
          this.checkFormError('date', true);
          if(this.dateError){
            return this.view.modalAlert(this.lang.attenzione, this.dateError, 'warn', this.lang.ok);
          }
          break;
        case 4:
          this.saveLink();
          return;
      }
    }
    this.pageContent += val;
    if(this.pageContent <= 0 || this.pageContent > 6){
      return this.dismiss();
    }
    ViewService.updateView.next(undefined);
  }

  async checkFormError(input: string, noTimeout?: boolean){
    if(!noTimeout) await Utility.wait(500);
    switch (input) {
      case 'vehicle':
        if(!this.vehicle){
          this.vehicleError = this.lang.seleziona_veicolo_errore;
          ViewService.updateView.next(undefined);
          return;
        }
        this.vehicleError = undefined;
        break;
      case 'date':
        if(!this.date || moment().isAfter(moment(this.date))){
          this.dateError = this.lang.data_nel_passato;
          ViewService.updateView.next(undefined);
          return;
        }
        this.dateError = undefined;
        break;
      // case 'features':
      //   let feature: any = this.features.find((elem: any) => {
      //     return elem.val === true;
      //   });
      //   if(!feature){
      //     this.featuresError = this.lang.selezionare_almeno_una_funzionalita;
      //     ViewService.updateView.next(undefined);
      //     return;
      //   }
      //   this.featuresError = undefined;
      //   break;
    }
    ViewService.updateView.next(undefined);
  }

  selectVehicle(vehicle: Partecipant) {
    if(!this.vehicle || this.vehicle._id !== vehicle._id){
      this.vehicle = vehicle;
      if(!this.note){
        this.note = this.translate.instant('CONDIVISIONE_POSIZIONE_ADD.note_default', {
          email: this.data.selOrganization.login_email_partecipant_owner,
          veicolo: this.vehicle.name || this.vehicle.imei
        });
      }
      ViewService.updateView.next(undefined);
    }
  }

  addTime(event: any){
    switch(event.id){
      case '1h':
        this.date = moment(this.date).add(1, 'h').format('YYYY-MM-DDTHH:mm');
        break;
      case '1gg':
        this.date = moment(this.date).add(1, 'd').format('YYYY-MM-DDTHH:mm');
        break;
      case '1sett':
        this.date = moment(this.date).add(7, 'd').format('YYYY-MM-DDTHH:mm');
        break;
    }
    this.checkFormError('date', true);
  }

  changeDate(event: any){
    this.date = event.detail.value;
    this.checkFormError('date', true);
  }

  addEmail(){
    if(this.tempEmail){
      if(!Utility.validateEmail(this.tempEmail)){
        return this.view.modalAlert(this.lang.attenzione, this.lang.email_invalida, 'warn', this.lang.ok);
      }
      for(let email of this.emails){
        if(email === this.tempEmail){
          this.tempEmail = undefined;
          ViewService.updateView.next(undefined);
          return;
        }
      }
      this.emails.push(this.tempEmail);
      this.tempEmail = undefined;
      ViewService.updateView.next(undefined);
    }
  }

  removeEmail(email: string, i: number){
    if(this.emails.length > i){
      if(this.emails[i] === email){
        this.emails.splice(i, 1);
        ViewService.updateView.next(undefined);
      }
    }
  }

  async showCopySuccess(){
    console.log(this.url)
    await Clipboard.write({
      string: this.url
    });
    this.show_testo_copiato = true;
    ViewService.updateView.next(undefined);
    setTimeout(() => {
      this.show_testo_copiato = false;
      ViewService.updateView.next(undefined);
    }, 3000)
  }

  async saveLink(){
    try{
      this.pageContent = 5; // loading
      ViewService.updateView.next(undefined);
      if(!this.link){
        // Creazione nuovo link
        const response: any = await this.api.postCondivisionePosizione(this.data.selOrganization.me._id, this.vehicle.imei, this.name, this.note, moment(this.date).valueOf(), this.emails);
        this.link = new CondivisionePosizione(response);
        this.url = this.link.url;
        this.changePageContent(1);
      }else{
        // modifica link
        const response: any = await this.api.patchCondivisionePosizione(this.data.selOrganization.me._id, this.link._id, this.name, this.note, moment(this.date).valueOf());
        this.link.setData(response)
        this.changePageContent(1);
      }
      ViewService.updateView.next(undefined);
    }catch(err){
      console.error(err);
      this.dismiss();
      this.view.modalAlert(this.lang.errore, this.lang.impossibile_salvare, 'warn', this.lang.ok);
    }
  }

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      this.view.pipeChanged++;
      this.cd.markForCheck();
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
